import { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import { formatTimeForDisplay } from '@usas/ui-web/utils/TimesUtils';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ event, onCheckboxChange, bonus, onAddOverrideEntryClicked, onEditOverrideEntryClicked }) => {
  return (
    <tr key={event.meetEventId}>
      <td>{event.eventCode || ''}</td>
      <td>{event.eventCompetitionGenderTypeName || ''}</td>
      <td>{event.ageGroupName || ''}</td>
      <td>{event.meetSessionName || ''}</td>
      <td>{event.entryTime ? formatTimeForDisplay(event.entryTime) : 'NT'} {event.entryTime ? event.qualifyingCourseCode || '' : ''}</td>
      <td>{event.isAlternateEvent === true ? `ALT: ${event.qualifyingEventCode || ''}` : event.isNonConformingTime === true ? `NC: ${event.qualifyingEventCode || ''}` : `${event.qualifyingEventCode || ''}`}</td>
      <td>
        {(event.hasQualifyingTime === true || event.swimTimeEntryOverride === true) ?
          <Fragment>
            <div className='pull-left'>
              {event.individualEventEntered === false ?
                <Fragment>
                  {(event.hasPaid === false || event.canBeDeleted === true) ?
                    <Checkbox
                      className={global.IconButton}
                      label=""
                      name="isSelected"
                      onChange={(e) => { onCheckboxChange(e, event.meetEventId) }}
                      checked={event.isSelected === true && event.qualifiedAsBonus === bonus} /> :
                    <Checkbox
                      className={global.IconButton}
                      label=""
                      name="isSelected"
                      onChange={(e) => { onCheckboxChange(e, event.meetEventId) }}
                      checked={event.isSelected === true && event.qualifiedAsBonus === bonus}
                      disabled={true} />}
                </Fragment>
                :
                <Checkbox
                  className={global.IconButton}
                  label=""
                  name="isSelected"
                  onChange={(e) => { onCheckboxChange(e, event.meetEventId) }}
                  checked={event.qualifiedAsBonus === bonus}
                  disabled={true} />
              }
            </div>
            {event.individualEventEntered === false ?
              <Fragment>
                {event.swimTimeEntryOverride === true ?
                  <Fragment>&nbsp;&nbsp;<ActionIntraPageButton onClick={(e) => onEditOverrideEntryClicked(e, event)}>Edit Override Time</ActionIntraPageButton></Fragment> :
                  <Fragment>&nbsp;&nbsp;<ActionIntraPageButton onClick={(e) => onAddOverrideEntryClicked(e, event)}>Add Override Time</ActionIntraPageButton></Fragment>}
              </Fragment> :
              <div style={{ marginLeft: '30px' }}>{event.individualEventEnteredOmeMeetName ? `Entered under ${event.individualEventEnteredOmeMeetName}` : ''}</div>}
          </Fragment>
          :
          <Fragment>
            {event.individualEventEntered === false ?
              <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ActionIntraPageButton onClick={(e) => onAddOverrideEntryClicked(e, event)}>Add Override Time</ActionIntraPageButton></Fragment> :
              <Fragment>{event.individualEventEnteredOmeMeetName ? `Entered under ${event.individualEventEnteredOmeMeetName}` : ''}</Fragment>}
          </Fragment>
        }
      </td>
    </tr>
  );
};

const OrgUnitAdminRosterEntriesSelectionLargeGrid = ({ gridData, isLoading, onCheckboxChange, bonus, onAddOverrideEntryClicked, onEditOverrideEntryClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th style={{ minWidth: '90px' }}>Event</th>
        <th style={{ minWidth: '115px' }}>Comp. Category</th>
        <th style={{ minWidth: '80px' }}>Age Group</th>
        <th>Session</th>
        <th style={{ minWidth: '100px' }}>Entry Time</th>
        <th style={{ minWidth: '90px' }}>Time Event</th>
        <th style={{ minWidth: '230px' }}>Select</th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan="7">Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0 ?
          gridData.map((event, i) =>
            <GridRow
              key={i}
              event={event}
              onCheckboxChange={onCheckboxChange}
              bonus={bonus}
              onAddOverrideEntryClicked={onAddOverrideEntryClicked}
              onEditOverrideEntryClicked={onEditOverrideEntryClicked} />)
          :
          <tr>
            <td colSpan={7}>No Results</td>
          </tr>
      }
    </tbody>
  </table>
);

export default OrgUnitAdminRosterEntriesSelectionLargeGrid;